export default {
  data() {
    return {
      is_full: false,
      searchVal:'',
    }
  },
  computed: {
    class_: {
      get() {
        let tmp='works-filter__block works-filter__block-list';
        if ( !this.is_show ) tmp+=' works-filter__block-advanced';
        return tmp;
      }
    },

    advanced: {
      get () {
        return (this.is_show || this.$store.getters.advanced);
      }
    },

    values_genre:{
      get () {
        return this.$store.getters.genres;
      }
    },

    filteredValues_genre(){
      if (this.searchVal.length>0) {
        var str = this.searchVal;
        return this.values_genre.filter(function(el){
          return el.label.toLowerCase().includes(str.toLowerCase());
        });
      }

      return this.values_genre
    },

    genre: {
      get () {
        var arr = new Object()
        var genre = this.$store.getters.filters.genre;

        this.values_genre.forEach(function(currentValue){
          if (genre !== undefined) {
            arr[currentValue.value]= genre.includes(currentValue.value)
          }
          else {
            arr[currentValue.value]=false;
          }
        })
        return arr;
      },
    }
  },

  methods: {
      change_val_genre(val){
        var genre = this.genre
        var arr = []
        Object.keys(genre).map(function (vkey, vind) {
          if(genre[vkey]){
            arr.push(vkey)
          }
        })
        var arr_tags = []

        arr.forEach((el,index)=>{
          this.values_genre.forEach((vel)=>{
            if(el === vel.value){
              arr_tags.push({ key: vel.value, value: vel.label})
            }
          })
        })

        if(undefined !== val && null !== val && undefined !== val['value']) {
          this.$store.dispatch ('setFilters', {'p':1, genre: arr}).then (() => {
            this.$store.dispatch ('setTags', {
              genre: arr_tags
            }).then(()=>{

            })
          })
        }
      },

      show_full(){
        this.is_full=true;
        setTimeout( ()=>{
          this.$refs.search.focus();
        },100 );
      }
  },

  updated: function () {
    this.$nextTick(function () {
      this.$emit('updated');

      $('.list-container').data('updated', '1');//чтобы обновить скроллер
    })
  },

  created   : function () {
    this.$store.dispatch ('addUsedFilters', 'Genres');
  },
  destroyed : function () {
    this.$store.dispatch ('removeUsedFilters', 'Genres');
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/filter/FilterGenreMix.js
// module id = null
// module chunks = 